import PropTypes from 'prop-types'
import { Box } from '@redriverpress/system'

const SIZE = '2rem'

const variantStyles = {
  done: {
    backgroundColor: 'blue500',
    color: 'white',
  },
  active: {
    borderColor: 'blue500',
    borderStyle: 'solid',
    borderWidth: 2,
    color: 'blue500',
  },
}

export default function StepCircle({ variant, label }) {
  return (
    <Box
      borderRadius='circular'
      boxShadow={1}
      width={SIZE}
      height={SIZE}
      display='flex'
      alignItems='center'
      justifyContent='center'
      fontWeight='600'
      {...variantStyles[variant]}
    >
      {label}
    </Box>
  )
}

StepCircle.defaultProps = {
  variant: 'default',
}

StepCircle.propTypes = {
  variant: PropTypes.oneOf(['default', 'done', 'active']),
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
}
